import { Vue } from 'vue-property-decorator';

export const QR_QUERY_PARAMETER = 'id';

export const eventHub = new Vue();
